module.exports = __webpack_public_path__ + "static/img/link3.c98bf5b9.png";